export * as uri from './uri'

// Scroll to anchor
export { scroll } from './scroll'

// Methods tags, canonical, robots
export * as meta from './meta'